/**
 * @generated SignedSource<<a605df18c184a4e85e693a94c89c4826>>
 * @relayHash 802d583fb4f3f4efb2817db65cb6e990
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c6f561c145f91026fce72350c7565ad214d681041018e535f2b5de0805a0196c

import type { ConcreteRequest, Query } from 'relay-runtime';
export type getGroupPropsQuery$variables = {
  cloudId: string;
};
export type getGroupPropsQuery$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly suggestedGroups: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly displayName: string;
            readonly jqlTerm: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
};
export type getGroupPropsQuery = {
  response: getGroupPropsQuery$data;
  variables: getGroupPropsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = {
  "concreteType": "JiraQuery",
  "kind": "LinkedField",
  "name": "jira",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "JiraJqlBuilder",
      "kind": "LinkedField",
      "name": "jqlBuilder",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Literal",
              "name": "context",
              "value": "GROUP"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 10
            }
          ],
          "concreteType": "JiraJqlGroupFieldValueConnection",
          "kind": "LinkedField",
          "name": "suggestedGroups",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraJqlGroupFieldValueEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraJqlGroupFieldValue",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "jqlTerm"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "displayName"
                    }
                  ]
                }
              ]
            }
          ],
          "storageKey": "suggestedGroups(context:\"GROUP\",first:10)"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "getGroupPropsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": (v1/*: any*/),
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getGroupPropsQuery",
    "selections": [
      (v1/*: any*/)
    ]
  },
  "params": {
    "id": "c6f561c145f91026fce72350c7565ad214d681041018e535f2b5de0805a0196c",
    "metadata": {},
    "name": "getGroupPropsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "eaf89078882595972874e548851d9e4e";

export default node;
